import React, { FC } from "react";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";
const Nodata: FC<{ bgColor?: boolean }> = ({ bgColor }) => {
  return (
    <>
      <div
        className={` flex items-center ${
          !bgColor ? "" : "bg-white"
        } justify-center py-2 h-full`}
      >
        <img src={NodataAvailable} alt="No data available" />
      </div>
    </>
  );
};
export default Nodata;
